import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
// import { JssProvider, createGenerateId } from 'react-jss'

import { StyledEngineProvider } from '@mui/material/styles';

import './MuiClassNameSetup';
import { StylesProvider, createGenerateClassName } from '@mui/styles';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
ChartJS.register(ArcElement, Tooltip, Legend);
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const env = process.env.NODE_ENV;
const seedVal = `seed-${env}`;
const generateClassName = createGenerateClassName({
  productionPrefix: 'prod',
  disableGlobal: true,
  seed: seedVal
});

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <StyledEngineProvider injectFirst>
          <StylesProvider generateClassName={generateClassName}>
            <App />
          </StylesProvider>
        </StyledEngineProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
